import { render, staticRenderFns } from "./CaptchaModal.vue?vue&type=template&id=2e1053b7&scoped=true"
import script from "./CaptchaModal.vue?vue&type=script&lang=js"
export * from "./CaptchaModal.vue?vue&type=script&lang=js"
import style0 from "./CaptchaModal.vue?vue&type=style&index=0&id=2e1053b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1053b7",
  null
  
)

export default component.exports